package app.properties

data class CreditType(var id: String?,
                      var name: String)